<template>

  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat"
    :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">
    <div class="flex flex-col items-center my-28 font-antonio-light text-center px-4">

      <a href="https://cordobatechweek.com" target="web">
        <img class="w-full" src="@/assets/logo.png" />
      </a>

      <span class="text-white text-2xl md:text-3xl text-center" style="color: #cae954">ACELERANDO LA REVOLUCIÓN DE LA
        IA</span>
      <span class="text-white text-2xl md:text-3xl my-2 text-center" style="color: #418ea7;">12 y 13 de Noviembre</span>
      <span class="text-white text-2xl md:text-3xl text-center" style="color: #418ea7;">Centro de Convenciones
        Córdoba</span>
    </div>
  </header>

</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>